import { fromScaled, toScaled, type DecimalString } from '@/lib/decimal';
import { InvalidQty, type QtyValue } from '@/lib/qty';

const PLACES = 3; // количество в API — до грамма

export interface LineBalance {
  /** Принято = отгружено − не принято; null — ввод ещё не разобран. */
  accepted: DecimalString | null;
  over: boolean;
  invalid: boolean;
}

export type BalanceSummary = 'ok' | 'none' | 'all' | 'invalid';

/**
 * Живой баланс формы «Принято частично» — те же правила, что у API (services/acceptance.py):
 * по строке не принято ≤ отгружено; хотя бы одна строка с возвратом («иначе это принято
 * полностью»), но не всё целиком («иначе это возврат»).
 */
export function acceptanceBalance(
  lines: readonly { shipped: DecimalString; returned: QtyValue | undefined }[],
): { lines: LineBalance[]; summary: BalanceSummary } {
  let any = false;
  let all = true;
  let invalid = false;
  const out: LineBalance[] = [];
  for (const { shipped, returned } of lines) {
    if (returned instanceof InvalidQty) {
      invalid = true;
      all = false;
      out.push({ accepted: null, over: false, invalid: true });
      continue;
    }
    const qty = toScaled(shipped, PLACES);
    const back = returned ? toScaled(returned, PLACES) : 0n;
    const over = back > qty;
    if (over) invalid = true;
    if (back > 0n) any = true;
    if (back < qty) all = false;
    out.push({ accepted: over ? null : fromScaled(qty - back, PLACES), over, invalid: false });
  }
  const summary: BalanceSummary = invalid ? 'invalid' : !any ? 'none' : all ? 'all' : 'ok';
  return { lines: out, summary };
}
